import { request } from "services/api/util";

class ProductSubCategoryService {
  async getListProductSubCategory(param) {
    const config = {
      method: "get",
      url: `admin/productSubCategory`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
}

export default new ProductSubCategoryService();
